import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { useNavigate, useLocation } from "react-router-dom";
import "./WeddingPagination.css";

const parseNumber = (val, fallback) =>
  isNaN(Number(val)) ? fallback : Number(val);

const WeddingPagination = ({
  currentPage,
  setCurrentPage,
  totalItemsCount,
  itemsCountPerPage,
}) => {
  /* ---------- responsive #pages displayed ---------- */
  const pageRangeDisplayed =
    window.innerWidth > 750 ? 8 : window.innerWidth > 470 ? 4 : 2;

  /* ---------- query‑string helpers ---------- */
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const [activePage, setActivePage] = useState(
    parseNumber(query.get("page"), currentPage) == 0 ? 1 :  parseNumber(query.get("page"), currentPage)
  );

  console.log('active page initially',activePage)

  /* ---------- keep parent in sync ---------- */
  useEffect(() => {
    setCurrentPage(activePage);
    query.set("page", activePage);
    navigate({ search: `?${query.toString()}` }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage]);

  /* ---------- buttons ---------- */
  const totalPages = Math.ceil(totalItemsCount / itemsCountPerPage);
  const prevDisabled = activePage === 1;
  const nextDisabled = activePage === totalPages;

  return (
    <div className="custom-pagination-wedding">
      <p
        onClick={() => !prevDisabled && setActivePage(activePage - 1)}
        className={prevDisabled ? "prev-button-disabled" : "prev-button"}
      >
        Prev
      </p>

      <Pagination
        activePage={activePage}
        itemsCountPerPage={itemsCountPerPage}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pageRangeDisplayed}
        onChange={setActivePage}
      />

      <p
        onClick={() => !nextDisabled && setActivePage(activePage + 1)}
        className={nextDisabled ? "next-button-disabled" : "next-button"}
      >
        Next
      </p>
    </div>
  );
};

export default WeddingPagination;
